// Opportunities (MCX and NFO): what a trader checks before pressing Add (UI/UX audit Phase 4).
// The ranking uses last traded prices; these cells show whether the legs can actually be traded:
// each leg's bid / ask spread, open interest on both legs, and whether the exchange is in session.
import React from "react";

/** (ask − bid) / mid in percent, or null without a two-sided quote. */
export function legSpreadPct(bid, ask) {
  const b = Number(bid), a = Number(ask);
  if (!(b > 0) || !(a > 0) || a < b) return null;
  return ((a - b) / ((a + b) / 2)) * 100;
}

const quote = (bid, ask) => (bid != null || ask != null ? `${bid ?? "—"} / ${ask ?? "—"}` : "no quote");

/** The WORSE leg's bid / ask spread; both legs' quotes in the tooltip. */
export function SpreadCell({ row, testId }) {
  const n = legSpreadPct(row.near_bid, row.near_ask);
  const f = legSpreadPct(row.far_bid, row.far_ask);
  const worst = n == null || f == null ? null : Math.max(n, f);
  const cls = worst == null ? "text-slate-600" : worst > 0.5 ? "text-[#FF6b62]" : worst > 0.2 ? "text-[#FFCC00]" : "text-slate-300";
  return (
    <span className={cls} data-testid={testId}
      title={`Near bid / ask ${quote(row.near_bid, row.near_ask)}${n == null ? "" : ` (${n.toFixed(2)}%)`}\nFar bid / ask ${quote(row.far_bid, row.far_ask)}${f == null ? "" : ` (${f.toFixed(2)}%)`}`}>
      {worst == null ? "—" : `${worst.toFixed(2)}%`}</span>
  );
}

/** {disabled, label, title} for a row's Add button. sessionOpen: true / false / undefined (unknown). */
export function addGate(row, { sessionOpen } = {}) {
  if (row.market_data_status && row.market_data_status !== "OK") {
    return { disabled: true, label: "ADD TRADE", title: `Prices are not live (${row.market_data_status}): this row cannot be added` };
  }
  if (!(Number(row.near_oi) > 0) || !(Number(row.far_oi) > 0)) {
    return { disabled: true, label: "ADD TRADE", title: "A leg has no open interest: an order there may never fill" };
  }
  if (sessionOpen === false) {
    return { disabled: false, label: "ADD · AT OPEN",
      title: "Market closed: the trade is set up now and enters only once the session opens and prices are live" };
  }
  return { disabled: false, label: "ADD TRADE", title: undefined };
}
